import {
    returnLengthListener,
    returnLengthHandler,
} from '@js/pages/returns/services/return/returnLengthHandler';

import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

window.addEventListener('DOMContentLoaded', () => {
    returnLengthListener();
});

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        const value = document.querySelector('.js-return-length:checked')?.value;
        returnLengthHandler(value);
        // returnLengthListener();
        console.log({ value });
    });
});

const bankAccountToggler = document.querySelector('.js-bank-account-toggler');
const bankAccountContainer = document.querySelector('.js-bank-account-container');

bankAccountToggler.addEventListener('change', (e) => {
    const { checked } = e.target;

    console.log({ bankAccountContainer, checked });

    if (checked) {
        bankAccountContainer.classList.remove('d-none');
        toggleAllInputsInContainer(bankAccountContainer, true);
    } else {
        bankAccountContainer.classList.add('d-none');
        toggleAllInputsInContainer(bankAccountContainer, false);
    }
});
